import React from 'react';

const PrivacyPolicyContainer = () => {
	return <div>Polityka prywatności</div>;
};

export default PrivacyPolicyContainer;
